import $ from 'jquery';
import AjaxForm, {parseHiddenFields} from '../AjaxForm';
import sendAjax from '../sendAjax';


let basePrices = {
  1: { // УСН 6%
    1  : 4000,
    31 : 6000,
    61 : 9000,
    101: 11000,
    151: 14000,
    201: 17000,
    301: 20000,
    451: 23000,
    601: Infinity,
  },
  2: { // УСН 15%
    1  : 5000,
    31 : 9000,
    61 : 11000,
    101: 14000,
    151: 17000,
    201: 20000,
    301: 23000,
    451: 28000,
    601: Infinity,
  },
  3: { // ОСНО
    1  : 7000,
    31 : 11000,
    61 : 16000,
    101: 19000,
    151: 25000,
    201: 30000,
    301: 35000,
    451: 40000,
    601: Infinity,
  },
};

let basePricesZero = {
  1: { // ИП
    0: { // Без сотрудников
      1: {1: null, 2: null, reports: null}, // УСН 6%
      2: {1: null, 2: null, reports: null}, // УСН 15%
      3: {1: 1000, 2: 2000, reports: 2}, // ОСНО
    },
    1: { // С сотрудниками
      1: {1: 2500, 2: 4000, reports: 5}, // УСН 6%
      2: {1: 2500, 2: 4000, reports: 5}, // УСН 15%
      3: {1: 3500, 2: 5000, reports: 7}, // ОСНО
    },
  },
  2: { // ООО
    0: { // Без сотрудников
      1: {1: 1000, 2: 2000, reports: 2}, // УСН 6%
      2: {1: 1000, 2: 2000, reports: 2}, // УСН 15%
      3: {1: 2000, 2: 2000, reports: 4}, // ОСНО
    },
    1: { // С сотрудниками
      1: {1: 2500, 2: 4000, reports: 5}, // УСН 6%
      2: {1: 2500, 2: 4000, reports: 5}, // УСН 15%
      3: {1: 3500, 2: 5000, reports: 7}, // ОСНО
    },
  },
};

function getValueFromRange(key, range) {
  let val = 0;
  for (let i in range) {
    if (!range.hasOwnProperty(i)) continue;
    if (key >= i) {
      val = range[i];
    } else {
      break;
    }
  }
  return val;
}

function fmt(number) {
  if (typeof number !== 'number') {
    return number;
  }

  return number.toFixed(0).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
}

function calcInitRangeSlider($el, options) {

  let $slider   = $('.ion-range-slider', $el);
  let modelName = $slider.data('model');

  $slider.ionRangeSlider({
    hide_min_max: true,
    hide_from_to: true,
    grid        : true,
    grid_margin : true,

    ...options,
  });

  let instance = $slider.data('ionRangeSlider');
  instance.update({from: this[modelName]});
  $('.form-control', $el).data('ionRangeSlider', instance);

}

let countDosMax     = 600;
let countDocsValues = [0, 30, 60, 100, 150, 200, 300, 450, countDosMax, `∞`];

export default {

  mixins: [AjaxForm],

  props: {
    api    : String,
    compact: Boolean,
  },

  data() {
    return {
      // Options
      ns          : 'calculator',
      isCompact   : true,
      viewForm    : false,
      // Calc params
      base        : 4000,
      tax         : 1,
      zero        : false,
      legal       : 1,
      team        : true,
      tariff      : 2,
      opt1        : false,
      opt2        : false,
      opt3        : false,
      docs        : 1,
      docsValue   : 30,
      staff       : 0,
      sum         : 0,
      sumDisplay  : '0',
      reportCount : '',
      contract    : false,
      // Form
      hiddenFields: {},
      state       : {},
      model       : {
        name   : '',
        company: '',
        tel    : '',
        mail   : '',
        message: '',
        accept : true,
      },
      messages    : {
        required: 'Поле не заполнено',
        accept  : 'Необходимо принять политику конфиденциальности и пользовательское соглашение',
        email   : 'Некорректный email',
      },
    };
  },

  created() {
    console.log('Calculator created');
    this.isCompact = !!this.compact;
    this.viewForm  = !this.isCompact;
  },

  mounted() {
    this.hiddenFields = parseHiddenFields(this.$el);

    calcInitRangeSlider.bind(this)($('.calculator-range-docs', this.$el), {
      from_min: 1,
      values  : countDocsValues,
      onChange: data => {
        this.docs      = data.from;
        this.docsValue = data.from_value;
        this.calculate();
      },
    });

    calcInitRangeSlider.bind(this)($('.calculator-range-staff', this.$el), {
      min     : 0,
      max     : countDosMax + 1,
      grid_num: (countDosMax + 1) / 100,
      onChange: data => {
        this.staff = data.from;
        this.calculate();
      },
    });

    this.calculate();
  },

  methods: {
    updateDocs(e) {
      let val   = e.target.value;
      let range = 0;
      countDocsValues.forEach((item, index) => {
        if (val >= item) range = index + 1;
        if (val > countDosMax) range = countDocsValues.length - 1;
      });

      this.docs = range;
      $(e.target).data('ionRangeSlider').update({from: range});
      this.calculate();
    },

    updateStaff(e) {
      $(e.target).data('ionRangeSlider').update({from: e.target.value});
      this.calculate();
    },

    isDisabledUSN() {
      return this.zero && this.legal === 1 && !this.team;
    },

    calculate() {
      if (this.isDisabledUSN()) {
        this.tax = 3;
      }

      this.zero
          ? this.calculateZero()
          : this.calculateDefault();
    },

    calculateDefault() {
      /*
       Без галочек
       Базовая ставка + (к-во_сотрудников*500)

       Осуществление производственной или строительной деятельности
       к предыдущему значению + 0,2*(Базовая ставка)

       Раздельный учет при наличии нескольких видов деятельности
       к предыдущему значению + 0,2*(Базовая ставка)

       Осуществление внешнеэкономической деятельности (ВЭД)
       к предыдущему значению + 0,25*(Базовая ставка)
       */
      // this.docsValue = countDocsValues[this.docs];
      this.base      = getValueFromRange(this.docsValue, basePrices[this.tax]);
      this.sum       = this.base + this.staff * 500;

      let opt1 = this.opt1 ? 0.2 * this.base : 0;
      let opt2 = this.opt2 ? 0.2 * this.base : 0;
      let opt3 = this.opt3 ? 0.25 * this.base : 0;

      this.sum += (opt1 + opt2 + opt3);

      this.contract   = (this.docs > 8 || this.staff > 600);
      this.sumDisplay = this.contract ? 'Цена договорная' : fmt(this.sum);
    },

    calculateZero() {
      console.log(basePricesZero);
      console.log(this.legal, Number(this.team), this.tax, this.tariff);
      this.sum         = basePricesZero[this.legal][Number(this.team)][this.tax][this.tariff];
      this.sumDisplay  = fmt(this.sum);
      this.reportCount = basePricesZero[this.legal][Number(this.team)][this.tax]['reports'];
    },

    showForm() {
      this.viewForm = true;
    },

    hideForm() {
      this.viewForm = !this.isCompact;
    },

    addData(fd) {
      fd.append('zero', this.zero);
      fd.append('tax', this.tax);
      fd.append('taxString', ['', 'УСН 6%', 'УСН 15%', 'ОСНО'][this.tax]);

      if (this.zero) {
        fd.append('legal', this.legal);
        fd.append('legalString', ['', 'ИП', 'ООО'][this.legal]);
        fd.append('team', this.team);
        fd.append('tariff', this.tariff);
        fd.append('tariffString', ['', 'Эконом', 'Стандарт'][this.tariff]);
        fd.append('reports', this.reportCount);
      } else {
        fd.append('docs', this.docs);
        fd.append('docsValue', this.docsValue);
        fd.append('staff', this.staff);
        fd.append('opt1', this.opt1);
        fd.append('opt2', this.opt2);
        fd.append('opt3', this.opt3);
        fd.append('contract', this.contract);
      }

      fd.append('sum', this.sum);

      return fd;
    },

    sendForm(e) {
      console.log('Send form', e, this.state);

      if (this.state.$invalid) {
        console.warn('Form invalid!');
        return;
      }

      let method = $(e.target).attr('method') || 'POST';
      let action = this.api;

      let fd = new FormData(e.target);

      fd.append('tax', this.tax);
      fd.append('taxString', ['', 'УСН 6%', 'УСН 15%', 'ОСНО', 'Нулевая отчетность'][this.tax]);
      fd.append('docs', this.docs);
      fd.append('docsValue', this.docsValue);
      fd.append('staff', this.staff);
      fd.append('opt1', this.opt1);
      fd.append('opt2', this.opt2);
      fd.append('opt3', this.opt3);
      fd.append('sum', this.sum);
      fd.append('contract', this.contract);

      // this.form.loading = true;
      // this.disableSubmit(e, true);

      sendAjax(action, {
        method: method,
        body  : fd,
      })
      .then((json) => {
        console.log('RESPONSE', json);
        console.log('RESPONSE $_POST', json['$_POST']);
        this.form.message = json['message'] || '';
        this.form.loading = false;
        this.showStatus();
        this.disableSubmit(e, false);
      })
      .catch((error) => {
        console.error(error);
        this.form.message = error.toString();
        this.form.loading = false;
        this.showStatus(false);
        this.disableSubmit(e, false);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./source/js/components/Calculator/Calculator.js